import moment from "moment";
import { Project } from "../interfaces";
import { capitalizeString, getCityNameByCode } from "../shared/util";

export class ProjectsAdapter {
    value: any;

    constructor(input: any) {
        this.value = input;
    }

    get update_date() {
        return moment(this.value.update_date).format("YYYY-MM-DD");
    }

    get created_at() {
        return moment(this.value.created_at).format("YYYY-MM-DD");
    }

    get city(){
        return getCityNameByCode(this.value.city).municipio;
    }


    get updated_at() {
        return moment(this.value.created_at).format("YYYY-MM-DD");
    }

    adapt(): Project {
        return {
            id: this.value.id,
            aliados_del_proyecto : this.value.aliados_del_proyecto,
            area_de_conocimiento : this.value.area_de_conocimiento.AREA_DE_CONOCIMIENTO,
            descripcion_detallada : this.value.descripcion_detallada,
            especialidad_de_conocimiento : this.value.especialidad_de_conocimiento.ESPECIALIDAD_DE_CONOCIMIENTO,
            estado_proyecto : this.value.estado_proyecto.estado,
            gran_area_de_conocimiento : this.value.gran_area_de_conocimiento.GRAN_AREA_DE_CONOCIMIENTO,
            presupuesto_estimado : this.value.presupuesto_estimado,
            products : this.value.products,
            tiempo_de_ejecucion_estimado : this.value.tiempo_de_ejecucion_estimado,
            tipo_proyecto : this.value.tipo_proyecto,
            descripcion : this.value.descripcion,
            titulo_proyecto : this.value.titulo_proyecto,
            user_created : this.value.user_created,
            user_updated : this.value.user_updated,
            created_at : this.created_at || '',
            updated_at : this.updated_at || '',
            capacity_type: this.value.actor_type,
            city: capitalizeString(this.city || ''),
        };
    }
}
